module.exports = __webpack_public_path__ + "static/img/empty.75ff1dd0.png";